import { HttpInterceptorFn, HttpRequest, HttpHandlerFn, HttpEvent } from '@angular/common/http';
import { Observable, from, switchMap } from 'rxjs';
import { fetchAuthSession } from 'aws-amplify/auth';

export const authInterceptor: HttpInterceptorFn = (req: HttpRequest<any>, next: HttpHandlerFn): Observable<HttpEvent<any>> => {
  
  if (shouldAddAuth(req.url)) {
    return from(getIdToken()).pipe(
      switchMap(idToken => {
        if (idToken) {
            const authReq = req.clone({
                setHeaders: {
                    'x-id-token': idToken
                }
            });
            return next(authReq);
        } else {
            return next(req);
        }
      })
    );
  }
  return next(req);
};

function shouldAddAuth(url: string): boolean {
    return (url.includes('api.public') || url.includes('localhost')) && url.includes('/v1/');
}

async function getIdToken(): Promise<string | null> {
  try {
        const session = await fetchAuthSession();
        const token = session.tokens?.idToken?.toString() || null;
        return token;
    } catch (error) {
        return null;
    }
}
